/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import { totp } from "otplib";
import { useK5u, hypenate } from "../helpers";
import classes from "../style/main.module.css";

const MAX = 30;
export const Home: React.FC<{ onLogout: () => void }> = ({ onLogout }) => {
  const [code, setCode] = useState<string>();
  const [tick, setTick] = useState<number>(0);
  const { crypto, bitmoji, displayName } = useK5u();

  async function newLink(): Promise<void> {
    try {
      const clipboard = await navigator.clipboard
        .readText()
        .catch(() => undefined);

      const url = window.prompt("Enter long link", clipboard);
      if (!url) return;

      const BASE = "https://u.kyle.kiwi/";
      const LEN = 4;
      const random = Math.random()
        .toString(36)
        .slice(13 - LEN)
        .padStart(LEN, "o");

      const shortCode = window.prompt("Enter short code", random);
      if (!shortCode) return;

      const form = new URLSearchParams();
      form.append("pin", crypto as string);
      form.append("code", shortCode);
      form.append("url", url);

      const { error } = await fetch(`${BASE}neu`, {
        method: "POST",
        body: JSON.stringify({
          pin: crypto,
          code: shortCode,
          url,
        }),
      }).then((r) => r.json());
      if (error) {
        window.alert(error);
        return;
      }

      try {
        if (!navigator.clipboard) throw new Error("Not Supported");
        await navigator.clipboard.writeText(BASE + shortCode);
        window.alert("Okay!");
      } catch {
        window.prompt("Generated", BASE + shortCode);
      }
    } catch {
      window.alert("Failed");
    }
  }

  useEffect(() => {
    if (!crypto) return (): void => undefined; // can't happen

    const id = setInterval(() => {
      const newCode = totp.generate(`${crypto}`);
      if (code !== newCode) {
        setCode(newCode);
        setTick(0);
      } else {
        setTick((n) => (n + 1) % MAX);
      }
    }, 1000);
    return (): void => clearInterval(id);
  }, [code, crypto]);

  // const couch = `https://render.bitstrips.com/v2/cpanel/10212285-${bitmoji?.id}-v1.png?transparent=1&palette=1`;

  return (
    <>
      <div
        className={classes.progress}
        style={{ width: `${((MAX - tick) / MAX) * 100}%` }}
      />
      <div className={classes.container}>
        {displayName && <p>Hi {displayName}</p>}

        {code ? <h1>{hypenate(code)}</h1> : <>Loading...</>}
        <br />
        <br />
        {bitmoji?.id && (
          <img
            src={`https://render.bitstrips.com/v2/cpanel/6d228887-e76d-4678-a578-a47592240081-${bitmoji.id}-v1.png?transparent=1&palette=1`}
            width={121}
            height={121}
            alt="Yeet"
            tabIndex={0}
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
            role="button"
            onClick={newLink}
          />
        )}
        <br />
        <br />
        <button type="button" onClick={onLogout}>
          Logout
        </button>
      </div>
    </>
  );
};
